import { render, staticRenderFns } from "./edit_admin.vue?vue&type=template&id=8059e912&"
import script from "./edit_admin.vue?vue&type=script&lang=js&"
export * from "./edit_admin.vue?vue&type=script&lang=js&"
import style0 from "./edit_admin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports